import React, { useCallback } from 'react';
import { SingleValue } from 'react-select';
import { Box, Flex } from '@chakra-ui/react';
import { KSelect } from '@/ui-library/components/molecules/KSelect';
import { KText } from '@/ui-library/components';
import { useTzOptions } from './useTzOptions';

interface TimeZoneSelectorProps {
  value: any;
  onChange: (value: { label: string; key: string }) => void;
  inputProps?: any;
}

interface TimeZoneOption {
  label: string;
  value: string;
  abbreviation: string;
  fullName: string;
  shortName: string;
}

export const TimeZoneSelectorV1: React.FC<TimeZoneSelectorProps> = ({
  value,
  onChange,
  inputProps,
}) => {
  const { customFilterOption, timeZoneOptions } = useTzOptions();

  const handleSelectChange = useCallback(
    (selected: SingleValue<TimeZoneOption>) => {
      if (selected) {
        onChange({ label: selected.label, key: selected.value });
      }
    },
    [onChange]
  );

  return (
    <Flex w="100%" gap="6px" flexDir="column">
      <KText color="secondary-900" size={inputProps?.size || 'sm-medium'}>
        Timezone {inputProps?.isRequired && <span style={{ color: 'red' }}>*</span>}
      </KText>
      <Box w="100%">
        <KSelect
          placeholder="Select time zone"
          value={
            timeZoneOptions.find((option) => option.value === value?.key) ||
            timeZoneOptions.find((option) => option.value === value)
          }
          options={timeZoneOptions}
          onChange={handleSelectChange}
          menuPlacement={inputProps?.menuPlacement || 'top'}
          filterOption={customFilterOption}
          {...inputProps}
        />
      </Box>
    </Flex>
  );
};
